module.exports = __webpack_public_path__ + "static/media/earnings1.917a8885.png";